module.exports = __webpack_public_path__ + "img/IMG_20191130_005234.5cd4edcb.jpg";